<script setup lang="ts">
import { createInput } from '@formkit/vue'
import MultipleSelect from './CreateInputBase/MultipleSelect.vue'

const multipleSelect = createInput<string | string[]>(MultipleSelect, { props: [
  'update',
  'multiSelectOptions',
  'placeholder',
  'isMultiSelectAllowed',
  'isOptionCreationAllowed',
  'isClearable',
  'hasSelectAll',
  'size',
  'isLoading',
] }, {
  help: null,
})
</script>

<template>
  <FormKit :type="multipleSelect" />
</template>
